export enum CustomBreakpoints {
  SMALL = '(max-width: 669.99px)',
  MEDIUM = '(min-width: 770px) and (max-width: 1099.99px)',
  LARGE = '(min-width: 1100px) and (max-width: 1999.99px)',
  XLARGE = '(min-width: 2000px)',
}
